import request from 'local_modules/request'
import actions from 'redux/actions'
import { constants, modals } from 'helpers'
import moment from 'moment'


const generateDriverSchedule = (data) => {
  return request.post(constants.lscSchedules.driversScheduleGenerate, data)
    .then(({ data }) => data)
}

const clearDriversSchedule = (date) => {
  return request.post(constants.lscSchedules.driversScheduleClear, {
    date: moment(date, 'DD.MM.YYYY').format('YYYY-MM-DD'),
  })
    .then(({ data }) => {
      if (data.errorMessage || data.successMessage) {
        actions.modals.open(modals.Dialog, {
          title: data.successMessage || data.errorMessage,
        })
      }

      return data
    })
}


export default {
  generateDriverSchedule,
  clearDriversSchedule,
}
